export const combobetUrl = 'https://combo.fp.kz';
// export const combobetUrl = 'http://172.28.4.121:3000';
export const allowedAccountResources = [1];


// WEBPACK FOOTER //
// ./js/constants/Combobet.js